import { AwardSnackbarMessage } from "components/AwardSnackbarMessage";
import AppMessage from "components/Translations/AppMessage";
import { SavePublicationResult } from "models/ApiModels";
import * as React from "react";


type Result = {
    message: React.ReactElement;
    messageOption: "success" | "trophy" | "success";
};

export function GetPublicationResultMessage(result: SavePublicationResult): Result {
    var r: Result = {
        message: null,
        messageOption: null,
    };

    if (result != null) {
        if (result.isDraft) {
            r.message = <AppMessage resource="PublicationDraftRegistered" />;
            r.messageOption = "success";
        }
        else if (!result.approved) {
            r.message = <AppMessage resource="PublicationRegisteredWithApproval" />;
            r.messageOption = "success";
        }
        else if (result.award) {
            r.message = <AwardSnackbarMessage award={result.award} />;
            r.messageOption = "trophy";
        }
        else if (result.isNewRecord) {
            r.message = <AppMessage resource="PublicationRegistered" />;
            r.messageOption = "success";
        }
        else {
            r.message = <AppMessage resource="PublicationUpdated" />;
            r.messageOption = "success";
        }
    }

    return r;
}